import Axios from 'axios'
export default class SigmaQueryLoader {
  constructor (store, options = {}) {
    this.store = store || this.$store || {}
    if (!this.store.hasOwnProperty('getters')) throw new Error('No store provided.')
    let instance = this.store.getters.getActiveInstance
    this.instanceUrl = (instance.url.endsWith('/') ? instance.url.slice(0, -1) : instance.url)
    this.jwt = instance.token
    this.queryString = `?instanceUrl=${this.instanceUrl}&jwt=${instance.token}`
    this.queryServer = this.store.getters.getSigmaQueryUrl ? this.store.getters.getSigmaQueryUrl : 'https://sigma-query.pa.revolutiones.com'

    this.reportOptions = options.reportOptions || {}
    this.selectedCodes = options.selectedCodes || {}
    this.includedTypes = options.includedTypes || {}
    this.currencyFactor = options.currencyFactor || 1
  }

  // Works with Stephen's App to get direct SQL
  async getReportData (report) {
    const reportTranslation = {
      glreport: '/reports/getalltransactions',
      taxreport: '/reports/get1099transactions',
      vendorreport: '/reports/getvendortransactions',
      trialbalance: '/reports/gettrialbalance',
      payrollinterface: '/reports/getpayrollinterface',
      employeeytd: '/reports/getemployeeytd',
      payrollcheckregister: '/reports/getpayrollcheckregister'
    }

    let postdata = {
      selectedCodes: this.selectedCodes,
      statusTypes: this.reportOptions.transactionStatuses,
      transactionTypes: this.includedTypes,
      reportCurrencyFactor: this.curencyFactor,
      includePOs: typeof this.reportOptions.includePOs === 'undefined' ? false : this.reportOptions.includePOs
    }

    try {
      const response = await Axios.post(this.queryServer + reportTranslation[report] + this.queryString, postdata)
      // console.log(response.data)
      if (response.status === 200) {
        return response.data
      } else {
        throw (response)
      }
    } catch (e) {
      throw (e)
    }
  }

  // Works with Stephen's App to get direct SQL
  async getCompanyData () {
    const allCodesUrl = '/codes/getallcodes'

    try {
      const response = await Axios.get(this.queryServer + allCodesUrl + this.queryString)
      // console.log(response.data)
      if (response.status === 200) {
        return response.data
      } else {
        throw (response)
      }
    } catch (e) {
      throw (e)
    }
  }

  // Works with Stephen's App to get direct SQL
  async getVendorData () {
    const allCodesUrl = '/codes/getallvendors'

    try {
      const response = await Axios.get(this.queryServer + allCodesUrl + this.queryString)
      // console.log(response.data)
      if (response.status === 200) {
        return response.data
      } else {
        throw (response)
      }
    } catch (e) {
      throw (e)
    }
  }
}
